export const drawerTheme = {
  header: {
    padding: 'var(--reset)',
  },
  content: {
    padding: 'var(--reset)',
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--p-primary-400)',
        color: 'var(--p-white)',
        shadow: 'var(--drawer-box-shadow)',
        borderColor: 'var(--p-primary-400)',
      },
    },
    dark: {
      root: {
        background: 'var(--p-primary-400)',
        color: 'var(--p-white)',
        shadow: 'var(--drawer-box-shadow)',
        borderColor: 'var(--p-primary-400)',
      },
    },
  },
};
